import _ from 'lodash';

export function toggleArrayValues<T>(
  values: T[],
  value: T,
  comparator: (value: T, other: T) => boolean = _.isEqual
): T[] {
  const existing = values.find((v) => comparator(v, value));
  return existing ? values.filter((v) => !comparator(v, value)) : [...values, value];
}
